import * as moment from "moment";
import * as React from "react";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { ICalendarEventEditorState } from "../ICalendarEventEditorState";

export function Decrement({
    state,
    setState,
}: {
    state: ICalendarEventEditorState;
    setState: React.Dispatch<React.SetStateAction<ICalendarEventEditorState>>;
}) {
    if (state.calendarEvent.name === `` || state.calendarEvent.isRepeating) {
        return null;
    }

    return (
        <div style={{ opacity: 0.65 }}>
            <IconWithText
                iconSuffix={EGlyphicon.minus}
                whenClicked={() => {
                    const newStartTime = moment(state.calendarEvent.start)
                        .subtract(1, "hours")
                        .format();

                    const newEndTime = moment(state.calendarEvent.end)
                        .subtract(1, "hours")
                        .format();

                    setState({
                        ...state,
                        calendarEvent: {
                            ...state.calendarEvent,
                            start: newStartTime,
                            end: newEndTime,
                        },
                    });
                }}
                displayAsBlock
            >
                decrement
            </IconWithText>
        </div>
    );
}
